import { FC, PropsWithChildren, useLayoutEffect } from 'react';
import { Trans } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useFetchStatisticsSoundOptionsQuery } from '../api/backendApi';
import { useAppSelector } from '../hooks/redux';
import { received as soundOptionsReceived } from '../store/soundOptions';

type PreloadProviderProps = PropsWithChildren;

export const PreloadProvider: FC<PreloadProviderProps> = ({ children }) => {
  const isAuthenticated = useAppSelector(state => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const {
    data: soundOptions,
    isLoading: isLoadingSoundOptions,
    isUninitialized
  } = useFetchStatisticsSoundOptionsQuery(
    {
      includesExtras: true
    },
    {
      skip: !isAuthenticated,
      selectFromResult: data => {
        return { ...data, data: data.data?.sound_options };
      }
    }
  );

  useLayoutEffect(() => {
    if (soundOptions) {
      dispatch(soundOptionsReceived(soundOptions));
    }
  }, [dispatch, isLoadingSoundOptions, soundOptions]);

  const isLoading =
    isLoadingSoundOptions || (isAuthenticated && isUninitialized);

  if (isLoading) {
    return <Trans i18nKey="loading" />;
  }

  return <div>{children}</div>;
};
